<section class="row">
  <!-- <div class="col-12">
    <div class="partnerhub-select-languages-lp float-right p-3 m-3">
      <select>
        <option
          *ngFor="let locale of availableTranslationLocales"
          (click)="onClickTranslationLocale(locale)"
          [selected]="currentTranslationLocale === locale.locale"
          [value]="locale.locale"
          >{{ locale.key }}</option
        >
      </select>
    </div>
  </div> -->

  <div class="col-md-5 d-flex flex-column">
    <ng-content></ng-content>
  </div>
  <div class="col-md-5 d-flex flex-column">
    <div class="lottie">
      <ng-lottie [options]="animationItem" (animationCreated)="animationCreated($event)"></ng-lottie>
    </div>
  </div>

  <ng-content select="[bottom]"></ng-content>
</section>
